import React from 'react';
import useToggleContext from './toggle-context';
import { useRefToFocusAfterClose } from './toggle';
import cn from 'classnames';
import { treatKeydownAsClick } from '~/helpers/events';
import './toggle-control-bar.scss';
export function getListboxId() {
    return `lbid-${Math.floor(Math.random() * 1010101)}`;
}
export default function ToggleControlBar({ Indicator, listboxId, children }) {
    const { isOpen, toggle } = useToggleContext();
    const [hasBeenOpened, setHasBeenOpened] = React.useState(false);
    const onKeyDown = React.useCallback((event) => {
        const keyList = isOpen ? ['Escape', 'Enter', ' '] : ['Enter', ' '];
        treatKeydownAsClick(event, keyList);
    }, [isOpen]);
    const focusRef = useRefToFocusAfterClose();
    const listboxProps = listboxId ? {
        'aria-haspopup': 'listbox',
        'aria-controls': listboxId
    } : {};
    React.useEffect(() => {
        if (isOpen) {
            setHasBeenOpened(true);
        }
    }, [isOpen]);
    // eslint-disable-next-line complexity
    React.useEffect(() => {
        var _a;
        if (hasBeenOpened && !isOpen) {
            // Restore focus to an input if there is one, otherwise to focusRef
            const focusOn = ((_a = focusRef === null || focusRef === void 0 ? void 0 : focusRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input')) || focusRef.current;
            focusOn === null || focusOn === void 0 ? void 0 : focusOn.focus();
        }
    }, [hasBeenOpened, isOpen, focusRef]);
    return (React.createElement("div", Object.assign({ className: cn('toggle-control-bar', { open: isOpen }), tabIndex: 0, onClick: () => toggle(), onKeyDown: onKeyDown, ref: focusRef, role: "combobox" }, listboxProps),
        React.createElement("div", null, children),
        React.createElement(Indicator, { isOpen: isOpen })));
}
